import { AdminLayout } from '../../components/admin/layout/AdminLayout';
import { QAManagement } from '../../components/admin/QAManagement';

export function QAPage() {
  return (
    <AdminLayout
      title="QA / Recette"
      description="Tests et assurance qualité"
    >
      <QAManagement />
    </AdminLayout>
  );
}
